import React from "react";
import style from "./style.module.scss";

const Name = () => (
  <div className={style.name}>
    <h1 className={style.name__name}>Ria Carmin</h1>
    <h2 className={style.name__title}>interface engineer</h2>
  </div>
);

export default Name;



// WEBPACK FOOTER //
// ./src/components/name/index.js